import { Exception } from './exception';

export class RouteParameterMissingException extends Exception {
  constructor(parameter: string, routeModel: string) {
    super(
      `Parameter "${parameter}" not given for constructing route "${routeModel}"`
    );
  }
}
